import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

interface IUseStyles {
  loading?: boolean
}

export const useTableStyles = makeStyles(
  theme =>
    createStyles({
      containerRoot: {
        display: 'flex',
        paddingBottom: 16,
        width: 'calc(100% + 16px)',
        margin: '0 -8px',

        '&::after': {
          content: '""',
          display: 'block',
          minWidth: 8,
        },

        '&::before': {
          content: '""',
          display: 'block',
          minWidth: 8,
        },
      },
      root: (props?: IUseStyles) => {
        if (props?.loading) {
          return {
            position: 'relative',
            minHeight: 300,
          }
        }
        return {}
      },
      table: {
        minWidth: 650,
        width: 'calc(100% - 16px)',
        borderCollapse: 'separate',
        borderSpacing: '0 8px',

        '& .MuiTableCell-root': {
          border: 'none',

          '&:first-of-type': {
            borderTopLeftRadius: 12,
            borderBottomLeftRadius: 12,
          },

          '&:last-of-type': {
            borderTopRightRadius: 12,
            borderBottomRightRadius: 12,
            paddingRight: 10,
          },
        },
      },
      tableHead: {
        '& .MuiTableCell-root': {
          background: theme.colors.greySemiLight,
          color: theme.colors.greySemiDark,
          fontSize: 12,
          fontWeight: 400,
          lineHeight: 1.5,
          whiteSpace: 'nowrap',
          padding: '8px 24px',
        },
      },
      tableBody: {
        '& .MuiTableCell-root': {
          background: theme.colors.white,
          padding: 24,
          transition: '.3s',
        },
        '& .MuiTableRow-root': {
          borderRadius: 12,
          transition: '.3s',

          '&:hover': {
            boxShadow:
              '0px 40px 80px -40px rgba(129, 129, 129, 0.07), 0px 30px 30px -20px rgba(129, 129, 129, 0.0503198), 0px 20px 20px -10px rgba(129, 129, 129, 0.0417275), 0px 12.5216px 10.0172px -5px rgba(129, 129, 129, 0.035), 0px 6.6501px 5.32008px rgba(129, 129, 129, 0.0282725), 0px 2.76726px 2.21381px rgba(129, 129, 129, 0.0196802)',

            '& .table-link': {
              textDecoration: 'underline',
            },
          },

          '&.vertical-top': {
            verticalAlign: 'top',
          },

          '& .table-link': {
            cursor: 'pointer',
          },
        },
      },
      tableBodyNoHover: {
        '& .MuiTableCell-root': {
          background: theme.colors.white,
          padding: 24,
          transition: '.3s',
        },
        '& .MuiTableRow-root': {
          borderRadius: 12,
          transition: '.3s',

          '&.vertical-top': {
            verticalAlign: 'top',
          },
        },
      },
    }),
  {
    index: 1,
  }
)
